import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/instance";
import { endpoints } from "../../constants/endpoints";

export const getCorporatesAPI = createAsyncThunk(
    "getCorporatesAPI",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await api.get(endpoints.getAllCorporates(payload));
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

export const getSingleCorporatesAPI = createAsyncThunk(
    "getSingleCorporatesAPI",
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.get(endpoints.getSongleCorporate(id));
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

export const UpdateStatusAPI = createAsyncThunk(
    "UpdateStatusAPI",
    async (data, { rejectWithValue }) => {
        const id = data?.id
        const status = data?.status

        try {
            const response = await api.post(endpoints.updateCorporateStatus(id, status));
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

const initialState = {
    corporates: [],
    singleCorporate: "",
    analytics: {
        total: 0,
        active: 0,
        pending: 0,
        blocked: 0,
    },
    pagination: {
        current_page: 1,
        total_pages: 1,
        total: 0,
        per_page: 10,
    },
    loading: false,
    error: null,
}

const SuperAdminCorporateSlice = createSlice({
    initialState,
    name: "SuperAdminCorporateSlice",
    reducers: {
        setPage: (state, action) => {
            state.pagination.currentPage = action.payload;
        },
    },
    extraReducers: (builder) => {
        // GET CORPORATES
        builder.addCase(getCorporatesAPI.pending, (state, action) => {
            state.loading = true
        })

        builder.addCase(getCorporatesAPI.fulfilled, (state, action) => {
            const corporatesData = action.payload.data.data.corporates;
            state.loading = false;
            state.corporates = corporatesData.data;
            state.analytics = action.payload.data.data.analytics;
            state.pagination = {
                current_page: corporatesData.current_page,
                total_pages: corporatesData.last_page,
                total: corporatesData.total,
                per_page: corporatesData.per_page,
            };
        })

        builder.addCase(getCorporatesAPI.rejected, (state, action) => {
            state.loading = false
        })
        // GET CORPORATES

        // GET SINGLE CORPORATE
        builder.addCase(getSingleCorporatesAPI.pending, (state, action) => {
            state.loading = true
        })

        builder.addCase(getSingleCorporatesAPI.fulfilled, (state, action) => {
            state.loading = false;
            state.singleCorporate = action.payload.data.data

        })

        builder.addCase(getSingleCorporatesAPI.rejected, (state, action) => {
            state.loading = false
        })
    }
})

export const { setPage } = SuperAdminCorporateSlice.actions
export default SuperAdminCorporateSlice.reducer